document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth <= 989) {
        document.querySelectorAll('.heading-container').forEach(heading => {
            heading.addEventListener('click', () => {
                heading.parentNode?.classList.toggle('active');
            });
        });
    }
});